import MENU from "~/menu.js";

export const state = () => ({
    menu: [],
    locale: false,
    isInitMenu: false,
    /**
     * @description Режим просмотра
     * default | edit | view
     */
    viewMode: 'default',
    availViewMode: [
        'default',
        'edit',
        'view'
    ]
});

export const actions = {
    async nuxtServerInit({ commit, dispatch }, { req }) {
        let auth = null;
        if (req.headers.cookie) {
            await this.$api("auth")
                .then(response => {
                    auth = response.data.user;
                })
                .catch(e => { })

        }
        commit('SET_MENU', MENU);
        commit('SET_AUTH', auth);
    },
    setViewMode({ commit }, params) {
        const isEdit = params?.status?.PROPERTIES?.EDIT_REQUEST == 'Y'
        const isView = !isEdit && !!params?.applications
        const mode = isEdit ? 'edit' : isView ? 'view' : 'default'
        commit('SET_VIEW_MODE', mode)
    },
    switchLocale({ commit, state }) {
        commit('SET_LOCALE', !state.locale);
    },
    addMenuHeader({ commit, getters }, { title, icon, link }) {
        if (!getters['isMenuHeaderByLink'](link)) {
            commit('ADD_MENU_HEADER', { title, icon, link })
        }
    },
    async initMenuHeader({ state, dispatch, commit }) {
        if (state.isInitMenu) {
            return
        }
        commit('SET_INIT_MENU', true)
        await dispatch('refreshMenuHeader')
    },
    async refreshMenuHeader({ commit }) {
        try {
            const response = await this.$api('getMenuItems')
            commit('SET_MENU_HEADER', response.data?.items ?? [])
        } catch (e) {
            // Не удалось получить меню
        }
    }
};

export const mutations = {
    SET_MENU: (state, menu) => {
        state.menu = menu;
    },
    SET_MENU_HEADER: (state, menu) => {
        state.menu.HEADER = menu?.map((e) => ({
            name: e.name ?? '',
            link: e.link ?? '',
            icon: e.icon ?? ''
        })) ?? []
        state.menu.MOBILEHEADER = menu?.map((e) => ({
            name: e.name ?? '',
            link: e.link ?? '',
            icon: e.icon ?? ''
        })) ?? []
    },
    SET_INIT_MENU: (state, value) => {
        state.isInitMenu = value ?? false
    },
    ADD_MENU_HEADER: (state, { title, icon, link }) => {
        state.menu.HEADER.push({ title, icon, link })
        state.menu.MOBILEHEADER.push({ title, icon, link })
    },
    REMOVE_MENU_HEADER_BY_LINK: (state, link) => {
        const tempArr = state.menu.HEADER.filter((e) => e.link !== link)
        if (tempArr.length >= 0 && tempArr.length !== state.menu.HEADER.length) {
            state.menu.HEADER = tempArr
        }
        const tempMobileArr = state.menu.MOBILEHEADER.filter((e) => e.link !== link)
        if (tempMobileArr.length >= 0 && tempMobileArr.length !== state.menu.MOBILEHEADER.length) {
            state.menu.MOBILEHEADER = tempMobileArr
        }

    },
    SET_LOCALE: (state, locale) => {
        state.locale = locale === true;
    },
    SET_AUTH: (state, auth) => {
        if (auth === null) {
            state.auth.user = null;
            state.auth.loggedIn = false;
        } else {
            state.auth.user = auth;
            state.auth.loggedIn = true;
        }
    },
    SET_VIEW_MODE: (state, mode) => {
        const availModes = [
            'default',
            'view',
            'edit'
        ]

        if (availModes.includes(mode)) {
            state.viewMode = mode
        } else {
            state.viewMode = availModes[0]
        }
    }
};

export const getters = {
    getLocale: (state) => {
        return state.locale;
    },
    getUserData: (state) => {
        return state.auth;
    },
    getMenu: (state) => {
        return state.menu;
    },
    getMenuHeader: (state) => {
        return state.menu.HEADER;
    },
    getMobileMenuHeader: (state) => {
        return state.menu.MOBILEHEADER;
    },
    getMenuFooter: (state) => {
        return state.menu.FOOTER;
    },
    isMenuHeaderByLink: (state) => (link) => {
        return !!state.menu.HEADER.find((e) => e.link === link)
    },
    getViewMode: (state) => {
        return state.viewMode ?? 'default'
    },
    getAvailModes(state) {
        return state.availViewMode;
    }
};
